
const common = {
  // General
  loading: "Loading...",
  error: "Error",
  success: "Success",
  cancel: "Cancel",
  save: "Save",
  edit: "Edit",
  delete: "Delete",
  confirm: "Confirm",
  close: "Close",
  
  // Common
  common: {
    back: "Back",
    cancel: "Cancel",
    delete: "Delete",
    notAvailable: "Not Available",
    saving: "Saving...",
    updating: "Updating...",
    save: "Save"
  }
};

export default common;
